// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PoundCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleOutlinedSvg
  }));
};

PoundCircleOutlined.displayName = 'PoundCircleOutlined';
export default React.forwardRef(PoundCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PoundCircleOutlined.js
// module id = 1605
// module chunks = 0